module.exports = __webpack_public_path__ + "img/date.164f4bfd.svg";